(() => {
  const strings = window.attendeeStrings;
  let busy = false;
  let revision = 0;
  let approvedForm = null;
  const checkoutSelector = '[data-attendee-checkout]';
  const cartFormIds = new Set(['cart', 'CartDrawer-Form', 'cart-notification-form']);
  const quantities = () => Array.from(document.querySelectorAll('cart-items input[name="updates[]"], cart-drawer-items input[name="updates[]"]'));
  const quantitySignature = () => quantities().map(input => `${input.dataset.index}:${input.value}`).join('|');
  const updating = () => Boolean(document.querySelector('.cart__items--disabled'));

  function enableButtons() {
    document.querySelectorAll(checkoutSelector).forEach(button => {
      if (button.dataset.attendeeEmpty !== 'true') button.disabled = false;
    });
  }

  function showError(anchor, message, lines = []) {
    const insertionPoint = anchor.closest('.cart__ctas') || anchor;
    const parent = insertionPoint.parentElement;
    let error = parent.querySelector('[data-attendee-error]');
    if (!error) {
      error = document.createElement('div');
      error.dataset.attendeeError = '';
      error.setAttribute('role', 'alert');
      error.tabIndex = -1;
      error.style.cssText = 'display:block;width:100%;box-sizing:border-box;margin:1.2rem 0;padding:1.2rem;border-left:4px solid #b42318;background:#fff1f0;color:#7a271a;text-align:left;overflow-wrap:anywhere;';
      parent.insertBefore(error, insertionPoint);
    }
    error.replaceChildren(document.createTextNode(message));
    for (const line of lines) {
      const paragraph = document.createElement('p');
      const link = document.createElement('a');
      const url = new URL(line.dataset.url, location.origin);
      if (url.origin !== location.origin) continue;
      link.href = url.href;
      link.textContent = `${line.dataset.title}: ${strings.correctNames}`;
      paragraph.append(link);
      error.append(paragraph);
    }
    error.focus();
  }

  async function check(anchor, proceed) {
    if (busy) return;
    if (updating()) {
      showError(anchor, strings.updating);
      return;
    }
    busy = true;
    anchor.setAttribute('aria-busy', 'true');
    const initialRevision = revision;
    const initialQuantities = quantitySignature();
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 10000);
    try {
      const url = new URL(window.routes.cart_url, location.origin);
      url.searchParams.set('section_id', 'attendee-cart-state');
      const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
      if (!response.ok) throw new Error('Cart unavailable');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const state = html.querySelector('[data-attendee-cart]');
      if (!state) throw new Error('Cart validation unavailable');
      const lines = Array.from(state.querySelectorAll('[data-attendee-line]'));
      if (!lines.length) throw new Error('Empty cart');
      if (initialRevision !== revision || initialQuantities !== quantitySignature() || updating()) {
        showError(anchor, strings.updating);
        return;
      }
      const pendingQuantity = quantities().some(input => {
        const line = lines[Number(input.dataset.index) - 1];
        return !line || Number(input.value) !== Number(line.dataset.quantity);
      });
      if (pendingQuantity) {
        showError(anchor, strings.updating);
        return;
      }
      const invalid = lines.filter(line => {
        const quantity = Number(line.dataset.quantity);
        if (!Number.isSafeInteger(quantity) || quantity < 1) return true;
        const names = line.dataset.names.split(/\s+and\s+|\s+&\s+|,|;|\n|\s+\/\s+/i).map(name => name.trim()).filter(Boolean);
        return (line.dataset.required === 'true' || names.length > 0) && names.length !== quantity;
      });
      if (invalid.length) {
        showError(anchor, strings.cartMismatch, invalid);
        return;
      }
      proceed();
    } catch {
      showError(anchor, strings.retry);
    } finally {
      clearTimeout(timeout);
      busy = false;
      anchor.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('input', () => { revision += 1; }, true);
  document.addEventListener('change', () => { revision += 1; }, true);
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!cartFormIds.has(form.id)) return;
    if (approvedForm === form) {
      approvedForm = null;
      return;
    }
    if (event.submitter && event.submitter.name !== 'checkout') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const button = event.submitter || document.querySelector(`${checkoutSelector}[form="${form.id}"]`) || form.querySelector(checkoutSelector);
    if (!button) return;
    check(button, () => {
      approvedForm = form;
      form.requestSubmit(button);
      approvedForm = null;
    });
  }, true);

  document.addEventListener('click', event => {
    if (event.target.closest('cart-remove-button')) revision += 1;
    const link = event.target.closest('a[href]');
    if (!link) return;
    const url = new URL(link.href, location.origin);
    if (url.origin !== location.origin || !/\/checkout\/?$/.test(url.pathname)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    check(link, () => location.assign(url.href));
  }, true);

  window.addEventListener('pageshow', () => {
    revision += 1;
    busy = false;
    approvedForm = null;
    enableButtons();
  });
  new MutationObserver(enableButtons).observe(document.body, { childList: true, subtree: true });
  enableButtons();
})();
